import Meta from './meta';
import RelatedSearch from './relatedSearch';
import Share from './share';
import ShareThird from './share/index-third';
import RelatedNews from './relatedNews';
import RelatedNewsFlow from './relatedNewsFlow';
import RelatedReading from './relatedReading';
import Main from './main';
import ShowMore from './showMore';
import MediaBar from './mediaBar/refactor';
import VideoPlayer from './videoPlayer';
import Comment from './comment';
import Ad from './ad';
import AdFeeds from './ad/index-feeds';
import Article from './article';
import Card from '../components/card';
import HotSearch from './hotSearch';
import GameOperation from '../components/gameOperation';
import NegativeFeedback from './negativeFeedback';
import Slogan from './slogan';
import EventCard from './eventCard/index';
import Banner from './banner/index';
import { browserPartner, showReSearch, showRecommended } from '../js/constants';
import wv from '@cpc/lib-browser-jsapi';

const meta = {
  name: 'meta',
  template: '<div component="meta" id="meta"></div>',
  component: Meta,
  type: 'feeds',
};

//自有详情页，媒体号的模板在document.html中，此组件定义媒体号相关的逻辑功能
const mediaBar = {
  name: 'mediaBar',
  template: '',
  component: MediaBar,
  type: 'feeds',
};

const banner = {
  name: 'banner',
  template: '',
  component: Banner,
  type: 'feeds',
};

const card = {
  name: 'card',
  template: '<div component="card"></div>',
  component: Card,
  type: 'feeds',
};

const hotSearch = {
  name: 'hotSearch',
  template: '<div component="hotSearch"></div>',
  component: HotSearch,
  type: 'feeds',
};

const videoPlayer = {
  name: 'videoPlayer',
  template: '',
  component: VideoPlayer,
  type: 'feeds',
};

// 热榜功能显示：默认为：0；【热榜不展示：0；热榜展示在第一个广告下方：1；热榜展示在第一个广告上方：2；】
const relatedSearch = {
  name: 'relatedSearch',
  template: '<div component="relatedSearch"></div>',
  component: RelatedSearch,
  type: 'feeds',
};

const eventCard = {
  name: 'eventCard',
  template: '<div component="eventCard"></div>',
  component: EventCard,
  type: 'feeds',
};

const share = {
  name: 'share',
  template: '<div component="share" class="share"></div>',
  component: Share,
  type: 'feeds',
};

const shareThird = {
  name: 'share',
  template: '<div component="share" class="share"></div>',
  component: ShareThird,
  type: 'feeds',
};

const ad_afterArticle = {
  name: 'ad',
  template:
    '<div component="ad" class="feeds-ad-common" id="flow-ad-detail-1" ref="ad"></div>',
  component: Ad,
  type: 'feeds',
};

const ad1Feeds = {
  name: 'ad',
  template:
    '<div component="ad" class="feeds-ad-common" id="flow-ad-detail-1" ref="ad"></div>',
  component: AdFeeds,
  type: 'feeds',
};

const relatedNews = {
  name: 'relatedNews',
  template:
    '<div component="relatedNews"  class="relatedNews" id="related-card"></div>',
  component: RelatedNews,
  type: 'feeds',
};

const relatedReading = {
  name: 'relatedReading',
  template: '<div component="relatedReading" class="relatedReading"></div>',
  component: RelatedReading,
  type: 'feeds',
};

const main = {
  name: 'main',
  template: '<div component="main"></div>',
  component: Main,
  type: 'body',
};

const showMore = {
  name: 'showMore',
  template: '<div component="showMore"></div>',
  component: ShowMore,
  type: 'showMore',
};

const article = {
  name: 'article',
  template: '<div component="article"></div>',
  component: Article,
  type: 'showMore',
};

const ad_afterRelatedNews = {
  name: 'ad',
  template:
    '<div class="feeds-ad-common" id="flow-ad-detail-2" ref="ad"></div>',
  type: 'feeds',
};

const comment = {
  name: 'comment',
  template: '',
  component: Comment,
  type: 'feeds',
};

const gameOperationTop = {
  name: 'gameOperationTop',
  template: '',
  component: GameOperation,
  type: 'gameCard',
};

const gameOperationBottom = {
  name: 'gameOperationBottom',
  template: '',
  component: GameOperation,
  type: 'gameCard',
};

const gameOperationFloat = {
  name: 'gameOperationFloat',
  template: '',
  component: GameOperation,
  type: 'gameCard',
};

// 负反馈组件
const negativeFeedback = {
  name: 'negativeFeedback',
  template: '<div component="negativeFeedback"></div>',
  component: NegativeFeedback,
  type: 'feeds',
};

// 口号组件
const slogan = {
  name: 'slogan',
  template: '<div component="slogan"></div>',
  component: Slogan,
  type: 'feeds',
};

// push 详情页无限流组件
const relatedNewsFlow = {
  name: 'relatedNewsFlow',
  template: '<div component="relatedNewsFlow"></div>',
  component: RelatedNewsFlow,
  type: 'feeds',
};

// 开关配置，是否显示推荐阅读模块
let isOpen = wv.isMethodValid('BrowserIFlow.getConfigValue')
  ? wv.getConfigValue('CommonConfig_RecommendReadEnabled')
  : { data: 0 };

// 端内自建源采用推荐阅读，其他场景均采用相关新闻
let relatedEle =
  browserPartner == 'browser' && isOpen.data == 1
    ? relatedReading
    : showRecommended === '0'
    ? ''
    : relatedNews;

export const feednewsComponentMap = {
  meta,
  negativeFeedback,
  slogan,
  mediaBar,
  eventCard,
  card,
  videoPlayer,
  share,
  ad_afterArticle,
  hotSearch,
  relatedSearch,
  relatedNews,
  relatedReading,
  // relatedEle,
  ad_afterRelatedNews,
  relatedNewsFlow,
  main,
  showMore,
  article, // 全文折叠功能依赖showMore组件
  comment,
  gameOperationTop,
  gameOperationBottom,
  gameOperationFloat,
};

// 自有-端外组件列表
export const feedsComponentMap = {
  meta,
  videoPlayer,
  ad1Feeds,
  relatedSearch,
  relatedNews,
  ad_afterRelatedNews,
};

// 极简模式组件列表
export const simpleComponentMap = {
  meta,
  videoPlayer,
};

// 小红书页面组件列表
export const smallRedBookComponentMap = {
  banner,
  meta,
  mediaBar,
  videoPlayer,
  ad_afterArticle,
  relatedEle,
  showMore,
  article,
  ad_afterRelatedNews,
  comment,
};

// 三方组件列表
let thirdComponentMap = {
  meta,
  mediaBar,
  eventCard,
  card,
  videoPlayer,
  share: shareThird,
  ad_afterArticle,
  hotSearch,
  relatedSearch,
  relatedNews,
  showMore,
  article,
  ad_afterRelatedNews,
  comment,
};

const vendor = window.pageData.DOCINFO?.vendor;

// sina源不需要加载mediaBar组件
vendor && vendor == 'sina' && delete thirdComponentMap.mediaBar;

export { thirdComponentMap };
